import ServiceCatalogueList from './ServiceCatalogueList';

export default {
  list: ServiceCatalogueList,
}
